import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Gr8piFormattedDate } from '../../../../../components/Gr8piFormattedDateTime';
import { generalTemplateSupportedLanguages } from '../../../../../utils/LanguageUtil';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  headerLanguage: {
    id: 'attrs.support_lang.language',
    defaultMessage: 'Languages',
  },
  headerQuestionnaire: {
    id: 'attrs.support_lang.questionnaire',
    defaultMessage: 'Questionnaire',
  },
  headerReport: {
    id: 'attrs.support_lang.report',
    defaultMessage: 'Report',
  },
  headerJPS: {
    id: 'attrs.support_lang.jps',
    defaultMessage: 'JPS',
  },
});

class TemplateMetaData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nodes: [],
    };
  }

  componentDidMount() {
    const { activeLocales, activeReportLocales, activeJSPLocales } = this.props;
    const nodes = [];

    const generalSupportedLangs = generalTemplateSupportedLanguages(
      activeLocales,
      activeReportLocales,
      activeJSPLocales,
    );

    if (ArrayUtil.isNotEmpty(generalSupportedLangs)) {
      generalSupportedLangs.forEach((supported) => {
        const quesSupport = activeLocales.find(lang => lang.value === supported.value);
        const reportSupport = activeReportLocales.find(lang => lang.value === supported.value);
        const JPSSupport = activeJSPLocales.find(lang => lang.value === supported.value);
        nodes.push({
          key: supported.value,
          data: {
            language: supported.label,
            questionaire: !!quesSupport,
            report: !!reportSupport,
            jps: !!JPSSupport,
          },
        });
      });
    }

    this.setState({ nodes: _.sortBy(nodes, node => node.data.language) });
  }

  render() {
    const {
      template,
      intl: { formatMessage },
    } = this.props;
    const { createdBy } = template;
    const author = createdBy ? `${createdBy.firstName} ${createdBy.lastName}(${createdBy.email})` : '';
    const { nodes } = this.state;
    const languageHeader = formatMessage(messages.headerLanguage);
    const questionnaireHeader = formatMessage(messages.headerQuestionnaire);
    const reportHeader = formatMessage(messages.headerReport);
    const jpsHeader = formatMessage(messages.headerJPS);

    return (
      <Panel>
        <div className="details">
          <span>
            <FormattedMessage id="attrs.created.verbose" defaultMessage="Created on" />
          </span>
          :
          <span>
            <Gr8piFormattedDate dateValue={template.createdOn} />
          </span>
        </div>
        <div className="details">
          <span>
            <FormattedMessage id="attrs.created_by" defaultMessage="Created by" />
          </span>
          :
          <span>{author}</span>
        </div>
        <div className="details">
          <span>
            <FormattedMessage id="attrs.updated.verbose" defaultMessage="Last update on" />
          </span>
          :
          <span>
            <Gr8piFormattedDate dateValue={template.updatedOn} />
          </span>
        </div>
        <div className="p-grid mt-25">
          <div className="p-col">
            <TreeTable value={nodes}>
              <Column field="language" header={languageHeader} />
              <Column
                field="questionaire"
                header={questionnaireHeader}
                body={(rowData) => {
                  const {
                    data: { questionaire },
                  } = rowData;
                  return (
                    <div align="center" className="box">
                      {questionaire ? (
                        <i className="fa fa-check icon-success" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-minus" aria-hidden="true" />
                      )}
                    </div>
                  );
                }}
              />
              <Column
                field="report"
                header={reportHeader}
                body={(rowData) => {
                  const {
                    data: { report },
                  } = rowData;
                  return (
                    <div align="center" className="box">
                      {report ? (
                        <i className="fa fa-check icon-success" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-minus" aria-hidden="true" />
                      )}
                    </div>
                  );
                }}
              />
              <Column
                field="jps"
                header={jpsHeader}
                body={(rowData) => {
                  const {
                    data: { jps },
                  } = rowData;
                  return (
                    <div align="center" className="box">
                      {jps ? (
                        <i className="fa fa-check icon-success" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-minus" aria-hidden="true" />
                      )}
                    </div>
                  );
                }}
              />
            </TreeTable>
          </div>
        </div>
      </Panel>
    );
  }
}

TemplateMetaData.propTypes = {
  template: PropTypes.objectOf(PropTypes.any).isRequired,
  activeLocales: PropTypes.objectOf(PropTypes.any).isRequired,
  activeJSPLocales: PropTypes.objectOf(PropTypes.any).isRequired,
  activeReportLocales: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TemplateMetaData);
